import moment from 'moment';
import { TimeUnits } from '../../util/index.js';
import { VoucherCategory } from '../vouchers/index.js';
import { dayIn } from './engine-v2/dates.js';
import { countryPeriods } from './policy.js';
import { getLimitationInterruptingPayments } from './vouchers.js';
export const expirationDatesCaseVouchers = (caseVouchers, foundations, countryCode, config) => {
    return caseVouchers.map((v) => {
        const calculatedExpirationDate = voucherExpirationDate(v, caseVouchers, foundations, countryCode, config);
        return {
            caseVoucherId: v.caseVoucherId,
            calculatedExpirationDate: calculatedExpirationDate
                ? calculatedExpirationDate.toISOString()
                : null,
            currentExpirationDate: v.expirationDate,
        };
    });
};
// An expiration date is the last day its debt is owed, a day in the tenant's
// calendar on both engines, so it has passed once that day is over.
export const isPastExpiry = (expirationDate, timezone, now = new Date()) => {
    const day = dayIn(timezone);
    return day(expirationDate) < day(now);
};
// What marking expired marks: vouchers past their stored expiry date, and those
// referring to one. Engine 2's calculated interest has no date of its own.
export const vouchersToMarkExpired = (caseVouchers, timezone) => {
    const pastExpiryIds = new Set(caseVouchers
        .filter((voucher) => voucher.expirationDate != null &&
        isPastExpiry(voucher.expirationDate, timezone))
        .map((voucher) => voucher.caseVoucherId));
    return caseVouchers.filter((voucher) => !voucher.expired &&
        voucher.category !== VoucherCategory.TRANSACTION &&
        (pastExpiryIds.has(voucher.caseVoucherId) ||
            (voucher.referenceCaseVoucherId != null &&
                pastExpiryIds.has(voucher.referenceCaseVoucherId))));
};
export const isVoucherExpired = (caseVoucher, caseVouchers, foundations, countryCode, config) => {
    const expirationDate = voucherExpirationDate(caseVoucher, caseVouchers, foundations, countryCode, config);
    return expirationDate ? moment().isAfter(expirationDate, 'day') : false;
};
export const voucherExpirationDate = (caseVoucher, caseVouchers, foundations, countryCode, config) => {
    if (caseVoucher.category === VoucherCategory.TRANSACTION) {
        return null;
    }
    const country = countryPeriods(countryCode);
    const normalExpiration = caseVoucher.expirationLength ??
        (config?.customExpiration?.normal
            ? config.customExpiration.normal
            : country.debt.ordinary);
    const normalExpirationWithFoundation = config?.customExpiration?.foundation
        ? config.customExpiration.foundation
        : country.debt.foundation;
    let relevantDate = caseVoucher.expirationFromDate || caseVoucher.date;
    let relevantExpirationDuration = normalExpiration;
    const normalizedData = normalizeData(getLimitationInterruptingPayments(caseVouchers), foundations);
    for (let i = 0; i < normalizedData.length; i++) {
        const element = normalizedData[i];
        switch (element.type) {
            case 'deposit':
                if (moment(relevantDate)
                    .add(relevantExpirationDuration, TimeUnits.YEARS)
                    .isBefore(moment(element.date).add(normalExpiration, TimeUnits.YEARS))) {
                    relevantDate = element.date;
                    relevantExpirationDuration = normalExpiration;
                }
                break;
            case 'foundation':
                if (moment(relevantDate)
                    .add(relevantExpirationDuration, TimeUnits.YEARS)
                    .isBefore(moment(element.date).add(normalExpirationWithFoundation, TimeUnits.YEARS))) {
                    relevantDate = element.date;
                    relevantExpirationDuration = normalExpirationWithFoundation;
                }
                break;
        }
    }
    return moment(relevantDate).add(relevantExpirationDuration, TimeUnits.YEARS);
};
const normalizeData = (deposits, foundations) => {
    const result = [];
    deposits.forEach((d) => {
        result.push({
            date: d.date,
            type: 'deposit',
        });
    });
    foundations &&
        foundations.forEach((f) => {
            result.push({
                date: f.signedAt || f.date,
                type: 'foundation',
            });
        });
    return result.sort((a, b) => (moment(a.date).isAfter(b.date) ? 1 : -1));
};
//# sourceMappingURL=expiration.js.map